import React from 'react';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: "Los tés 'detox' comerciales",
    desc: 'Son solo diuréticos que te hacen perder agua, pero no reparan el daño en tu pared intestinal.'
  }, {
    title: 'Las dietas bajas en carbohidratos',
    desc: 'Te dejan sin fuerza para aguantar tu jornada laboral y el cuidado de tu familia.'
  }, {
    title: 'Los consejos genéricos',
    desc: 'Ignoran que el maíz moderno y los aceites vegetales que usamos para freír son los principales disparadores de tu inflamación.'
  }, {
    title: 'Contar calorías',
    desc: "No sirve de nada si lo que comes está causando una respuesta inmune de 'alerta roja' en tu vientre."
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-forest mb-6" data-id="element-4">
            Por qué lo que has intentado no funciona
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-5"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-6">
          {failures.map((item, index) => <div key={index} className="bg-cream p-8 rounded-sm border border-sage/50 hover:border-gold/30 transition-colors duration-300 flex flex-col items-start" data-id="element-7">
              <div className="flex items-center gap-4 mb-4" data-id="element-8">
                <XCircle className="w-8 h-8 text-red-800/70 flex-shrink-0" strokeWidth={1.5} data-id="element-9" />
                <h3 className="text-xl font-heading font-bold text-forest leading-tight" data-id="element-10">
                  {item.title}
                </h3>
              </div>
              <p className="text-dark/80 font-body leading-relaxed pl-12" data-id="element-11">
                {item.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}